module.exports = __webpack_public_path__ + "static/media/carto-full-logo.73145fc1.svg";